import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { EngagementContactInteraction } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { EngagementViewerDialogService } from '../../engagement-viewer.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';

export function getSetup(service: EngagementViewerDialogService, util: UtilityService, dialog: DialogService, domainData: DomainDataService, app: AppService): GridSetup<EngagementContactInteraction & { updatedUTC: number }> {

	return {
		rowName: { singular: 'Interaction', plural: 'Interactions' },
		getRowKey: row => '' + row.engagementContactId,
		stateKey: 'follow-ups-grid',
		actions: getActions(service, dialog),
		buttons: getButtons(service, dialog),
		columns: getColumns(util, domainData, app),
	}
}
